import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";


const getSlotsUrl                    = '/api/doctor/scheduled/getSlots';
const getScheduledClientsUrl         = '/api/doctor/scheduled/getScheduledClients';
const scheduleClientUrl              = '/api/doctor/scheduled/scheduleClient';
const getMeetDetailForClientUrl      = '/api/doctor/scheduled/getMeetDetailForClient';
const getMeetDetailForDoctorUrl      = '/api/doctor/scheduled/getMeetDetailForDoctor';
const postFormUrl                    = '/api/doctor/scheduled/postForm';
const postJmerFormUrl                = '/api/doctor/scheduled/postJmerForm';
const postTmerFormUrl                = '/api/doctor/scheduled/postTmerForm';
const sendLinkUrl                    = '/api/doctor/scheduled/sendLink';


export const getSlots = async (date) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        getSlotsUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { date }} 
    );
    return response;
};

export const getScheduledClients = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getScheduledClientsUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const scheduleClient = async (schedule) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        scheduleClientUrl,
        { schedule },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const getMeetDetailForClient = async(roomId) => { 
    const response = await axiosGet( getMeetDetailForClientUrl, { headers: '', params: { roomId }} );
    return response;
}

export const getMeetDetailForDoctor = async(roomId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        getMeetDetailForDoctorUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { roomId }} 
    );
    return response;
}

export const postForm = async (clientId, form, media) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postFormUrl,
        { clientId, form, media },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postJmerForm = async (clientId, form, media) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postJmerFormUrl,
        { clientId, form, media },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const postTmerForm = async (clientId, form) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postTmerFormUrl,
        { clientId, form },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const sendLink = async(clientId, mobile) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( 
        sendLinkUrl, 
        { headers: { auth_token: `bearer ${token}` }, params: { clientId, mobile }} 
    );
    return response;
}